const styles = (theme) => ({
  navigationContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.hvSpacing("xs", 0),
  },
  navigationMonth: {
    minWidth: "160px",
  },
});

export default styles;
